import { apiRoutes } from "@constants/api-routes";
import { handleRequest } from "@utils/http-util";
import { RequestTypes } from "@enums/request-types";
import { WorkflowTemplate } from "@idw-types/data/reference-data/generic";

type GetWorkflowTemplateRequestResponse = {
    workflowTemplates: Array<WorkflowTemplate>;
};

export const getWorkflowTemplatesRequest = async (): Promise<{ data: GetWorkflowTemplateRequestResponse, error: any }> => {
    const route = apiRoutes.serviceConfiguration.data.workflowTemplate;

    const { data, error } = await handleRequest(RequestTypes.GET, route);
    return { data, error };
};